import { useCallback, useEffect, useState } from 'react';
import api from '../utils/api';
import { PartnerEndpoints } from '../utils/endpoints';

const usePartnerDetails = () => {
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(PartnerEndpoints.partnerDetails);
      setDetails(response.data?.data ?? {});
      setError('');
    } catch {
      setError('Could not load your settings. Please try again.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { details, loading, error, setError, refetch };
};

export default usePartnerDetails;
